import React, {Component, Fragment} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { translate } from 'react-i18next';
import BaseLayout from '../../../components/Layout/BaseLayout';
import AdCoreSlot from '../../../components/Ads/AdCoreSlot';
import RecipeList from '../../../components/Recipes/RecipeList';
import {RecipeCardPlaceholder} from '../../../components/Common/ContentPlaceholder';
import FeedSwitcherComponent from '../../../components/Layout/Sidebars/FeedSwitcher';
import {Icon} from '../../../components/Common/Icon';
import {RecipeDetail} from '../RecipeDetail';
import Template404Container from '../../404';
import { recipeDetailDataFetch, recipesListingDataFetch, topicTrendingListFetch } from '../../../actions/index';
import { mobileCheck, myIsSet } from '@tickled-media/web-components.tm-helpers';
import {getUrlImage, gtmSend} from '../../../helpers';
import cx from '../../../styles';
import Breadcrumbs from '../../../components/Layout/Breadcrumbs';

class RecipesListingContainer extends Component {

	constructor(props){
		super(props);
        
		this.state = {
			page: 1,
			eof: false,
            isShowDetail: false,
            activeDetailId: '',
            isListingEmpty: false
		};
	}

	componentDidMount(){
        const {listing} = this.props.recipeReducer;
        if(!(listing && listing.cuisine_info && listing.cuisine_info.key) ||
            (listing && 
                ((listing.cuisine_info && listing.cuisine_info.slug !== this.props.match.params.slug) ||
                    (listing.cuisine_info && listing.cuisine_info.key !== this.props.match.params.id)))){
    		this.props.recipesListingDataFetch(this.state.page, this.props.match.params.type, this.props.match.params.id)
            .then((response) => {
                if(!(response && response.recipes)){
                    this.setState({
                        isListingEmpty: true
                    });
                }
            });
        }
		this.requestSidebars();
		window.addEventListener("scroll", this.bindScrollEvent);
        window.addEventListener("popstate", this.toggleIsShowDetail);
	}

    componentDidUpdate(prevProps){
        if(prevProps.match.params.type !== this.props.match.params.type ||
            prevProps.match.params.id !== this.props.match.params.id){
            this.props.recipesListingDataFetch(1, this.props.match.params.type, this.props.match.params.id)
            .then((response) => {
                this.setState({
                    page: 1,
                    eof: false
                });
                window.scrollTo(0,0);
                if(!(response && response.recipes)){
                    this.setState({
                        isListingEmpty: true
                    });
                }
            });
        }
    }

	componentWillUnmount() {
        //remove scroll handler
        window.removeEventListener("scroll", this.bindScrollEvent);
        window.removeEventListener("popstate", this.toggleIsShowDetail);
    }

    bindScrollEvent = () => {      
        if(window.scrollY >= document.body.scrollHeight - window.innerHeight - 700) {
            if(!(this.props.recipeReducer.isLoading || this.state.eof)) {
                this.infiniteScrollHandler();
            };
        }
    }

    infiniteScrollHandler = () => {
        let nextLength;
        const page = this.props.recipeReducer.page + 1;

        const prevLength = this.props.recipeReducer.listing.recipes ? this.props.recipeReducer.listing.recipes.length : 0;

        this.props.recipesListingDataFetch(page, this.props.match.params.type, this.props.match.params.id)
        .then((response) => {
            nextLength = this.props.recipeReducer.listing.recipes ? this.props.recipeReducer.listing.recipes.length : 0;
            if(prevLength == nextLength) {
                this.setState({
                    eof: true
                });
            }
            if(!(response && response.recipes)){
                this.setState({
                    isListingEmpty: true
                });
            }
        });
    }

	requestSidebars = () => {
		if(!(mobileCheck() || this.props.appReducer.topicsTrendingSidebar.length)){
			this.props.topicTrendingListFetch();
		}
	}

	buildLeftSidebar = () => {
        const lc = [
            <FeedSwitcherComponent trendingTopicsElems={this.props.appReducer.topicsTrendingSidebar} appReducer={this.props.appReducer} />,
        ];

        return lc;
    }

    buildRightSidebar = () => {
    	const ads = this.props.configReducer.ads;
    	const rc = [
            ads.networkId &&
    		<div className={cx("shadow-card")}>
                <AdCoreSlot networkId={ads.networkId} 
                    adUnit={ads.common.half_page.unit}
                    styleClass={ads.common.half_page.styleClass}
                    size={[ads.common.half_page.w, ads.common.half_page.h]}
                    id={ads.common.half_page.id}/>
            </div>
    	];

    	return rc;
    }

    handleSliderBackClick = () => {
        gtmSend('dynamic','Recipes', 'Slide back click' , '');
        this.setState({
            isShowDetail: false,
            activeDetailId: ''
        });
        this.props.history.goBack();
    }

    onRecipeClick = (slug, id) => {
        gtmSend('dynamic event', 'Recipes', 'Recipes listing click', `/${slug}/${id}`);

        if(mobileCheck()) {
            this.setState({
                isShowDetail: true,
                activeDetailId: id
            });
            
            const url = `/recipe/${slug}/${id}`;
            window.history.pushState({}, "", url);
        }
        else {
            this.props.history.push(`/recipe/${slug}/${id}`);
        }
    }

    toggleIsShowDetail = () => {
        this.setState({
            isShowDetail: false,
            activeDetailId: ''
        });
    }

    render(){
        const {recipeReducer, history, match, landingUrl, serverReqCookie, location, t} = this.props;
        const {cuisine_info: cuisineInfo, recipes} = recipeReducer.listing;
        const recipeCategoryType = {
            'cuisine': 'cuisines',
            'stage': 'stages'
        };

        if(this.state.isListingEmpty){
            return (
                <Template404Container history={history} match={match} />
            );
        }
        else{
    		return (
    			<BaseLayout
    	            history={history} 
    	            match={match}
                    landingUrl={landingUrl}
                    serverReqCookie={serverReqCookie}
    	            className={'recipes-listing-page'}
    	            leftCards={this.buildLeftSidebar()}
    	            rightCards={this.buildRightSidebar()}
                >
                    <div className={cx('recipe-listing-container')}>                
                        <div className={cx('cuisine-title-wrap','not-mobile')}>
                            <span className={cx('close')} onClick={() => {history.goBack(); gtmSend('dynamic','Recipes','back button click','');}}><Icon name='btn-back'/></span>
                            {/*
                                myIsSet(this.props, 'recipeReducer.listing.cuisine_info') && cuisineInfo &&
                                <h1 className={cx('close')}>
                                    {cuisineInfo.label}
                                </h1>
                            */}
                        </div>

                        <div className={cx('recipes-listing-wrapper')}>
                            {
                                recipeReducer.listing &&
                                <Fragment>
                                    <div className={cx('recipe-listing-image')} style={{backgroundImage: `url(${cuisineInfo && cuisineInfo.cover_image && !recipeReducer.isLoading ? cuisineInfo.cover_image : getUrlImage({imgPath: "community-theasianparent/assets/food_placeholder.png"})})`}}>
                                        <span className={cx('close', 'only-mobile')} onClick={this.handleSliderBackClick}><Icon name="btn-back"/></span>
                                        <img className={cx('glass')} src={getUrlImage({imgPath: 'tap-assets/glass-featured-prime-block.png'})} alt="glass-placeholder" loading="lazy" />
                                    </div>
                                    {
                                        myIsSet(this.props, 'recipeReducer.listing.cuisine_info') && cuisineInfo &&
                                        <h1 className={cx('close')}>{cuisineInfo.label}</h1>
                                    }
                                    <div className={cx('recipes-list')}>
                                        <RecipeList recipes={recipes} clickHandler={this.onRecipeClick} isLoading={recipeReducer.isLoading} />
                                        {
                                            recipeReducer.isLoading && 
                                            <Fragment>
                                                <RecipeCardPlaceholder />
                                                <RecipeCardPlaceholder />
                                                <RecipeCardPlaceholder />
                                            </Fragment>
                                        }
                                    </div>
                                </Fragment>
                            }
                        </div>

                        <div className={cx('recipe-detail-viewer', this.state.isShowDetail ? 'active' : '')}>
                            <div>
                                <span className={cx('close')} onClick={this.handleSliderBackClick}><Icon name="btn-back"/></span>
                                {
                                    this.state.isShowDetail &&
                                    <RecipeDetail 
                                        t={t}
                                        recipeDetailDataFetch={this.props.recipeDetailDataFetch}
                                        recipeReducer={recipeReducer}
                                        id={this.state.activeDetailId} 
                                        toggleIsShowDetail={this.toggleIsShowDetail} 
                                        match={match} 
                                        history={history} />
                                }
                            </div>
                        </div>
                        
                        <Breadcrumbs links={[
                            { location: '/feed', label: 'Home' },
                            { location: '/recipes', label: 'Recipes' },
                            { location: `/recipes/${recipeCategoryType[match.params.type]}`, label: recipeCategoryType[match.params.type] },
                            { location: location.pathname, label: (cuisineInfo ? cuisineInfo.label : '') },
                        ]} />
                    </div>
    	        </BaseLayout>
    		);
        }
	}
}

// map state
const mapStateToProps = (state) => state;

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
        recipeDetailDataFetch,
		recipesListingDataFetch,
		topicTrendingListFetch
	},dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(RecipesListingContainer));